<div class="game-history-container">
  <table class="history-table">
    <thead>
      <tr>
        <th>Round No.</th>
        <th>Seat No.</th>
        <th>In Between</th>
        <th>Out Beyond</th>
        <th>P/T</th>
        <th>1ST Base Card</th>
        <th>2ND Base Card</th>
        <th>Maverick</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let history of gameHistoryData" class="bg-neutral-50 bg-opacity-10 even:bg-neutral-50 even:bg-opacity-30">
        <td>{{ history.dealNo }}</td>
        <td>{{ history.seatNo }}</td>
        <td>
          <div
            *ngIf="!validResultSvg(history.winningBet, gameResult.INBETWEEN); else resultInbetween"
            class="underline-result"
          >
            —
          </div>
        </td>
        <td>
          <div
            *ngIf="!validResultSvg(history.winningBet, gameResult.OUTBEYOND); else resultOutBeyond"
            class="underline-result"
          >
            —
          </div>
        </td>
        <td>
          <div
            *ngIf="
              !validResultSvg(history.winningBet, gameResult.HIGH, gameResult.LOW, gameResult.TRIO);
              else resultPair
            "
            class="underline-result"
          >
            —
          </div>
        </td>
        <td>
          <app-small-card [number]="history.firstCard.number" [type]="history.firstCard.cardType"></app-small-card>
        </td>
        <td><app-small-card [number]="history.secondCard.number" [type]="history.secondCard.cardType"></app-small-card></td>
        <td><app-small-card [number]="history.maverickCard.number" [type]="history.maverickCard.cardType"></app-small-card></td>
        <ng-template #resultInbetween>
          <svg-icon
            [svgClass]="'bg-white rounded-full'"
            [src]="'assets/svg/' + getResultSvg(history.winningBet, gameResult.INBETWEEN) + '.svg'"
          ></svg-icon>
        </ng-template>
        <ng-template #resultOutBeyond>
          <svg-icon
            [svgClass]="'bg-white rounded-full'"
            [src]="'assets/svg/' + getResultSvg(history.winningBet, gameResult.OUTBEYOND) + '.svg'"
          ></svg-icon>
        </ng-template>
        <ng-template #resultPair>
          <svg-icon
            [svgClass]="'bg-white rounded-full'"
            [src]="
              'assets/svg/' +
              getResultSvg(history.winningBet, gameResult.HIGH, gameResult.LOW, gameResult.TRIO) +
              '.svg'
            "
          ></svg-icon>
        </ng-template>
      </tr>
    </tbody>
  </table>
</div>
